export default __webpack_public_path__ + "static/media/z020mi0b.aca1d1b4.mp3";